import styled from "styled-components"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"

const AddressTitle = styled.h3`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const StyledLink = styled(TransitionFade)`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
`

const StyledLinkContainer = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const MailButton = styled.button`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
`

export { AddressTitle, StyledLink, MailButton, StyledLinkContainer }
